/* eslint-disable max-len */
import React from "react";

type IProps = {
  width?: number;
  height?: number;
};

const SvgComponent: React.FC<IProps> = ({ width = 20, height = 22 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 20 22" fill="none">
    <path d="M6 0.958984V4.95898M14 0.958984V4.95898M1 8.95898H19M3 2.95898H17C18.1046 2.95898 19 3.85441 19 4.95898V18.959C19 20.0636 18.1046 20.959 17 20.959H3C1.89543 20.959 1 20.0636 1 18.959V4.95898C1 3.85441 1.89543 2.95898 3 2.95898Z" stroke="#908E8D" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export default SvgComponent;
